import React from "react";
import Image from "next/image";
import styles from "./BannerVideo.module.css";
import close from "../../assets/icons/close-circle.svg";
import play from "../../assets/icons/playvideo.png";
import VideoPlay from "../VideoPlay";
import { useSelector } from "react-redux";
import { getImageType } from "../../utils/helper";
import useVideoHandlers from "./videoHandlers";
import { BannerVideoProps } from "./BannerVideo.type";

const BannerVideo = ({ data, isStyles }: BannerVideoProps) => {
  const {
    isPlaying,
    isVideo,
    handleVideoEnded,
    handlePlayVideo,
    handlePlay,
    handleCloseVideo,
    handlePause,
    handleSeek,
  } = useVideoHandlers();

  const playIcon = data?.icon?.results?.[0]?.fileUrl;

  const { isMobileDevice } = useSelector((state: any) => state?.data);
  return (
    <>
      {data && (
        <div
          className={`video-banner-sec ${isStyles ? "counter1" : "counter"}`}
          data-testid="bannervideo-container-id"
        >
          <div className="container pt-3">
            <div
              className={`banner-video ${
                isStyles ? styles.banner1 : styles.banner
              } ${isVideo ? styles.banner_border : ""}`}
            >
              {!isVideo ? (
                <>
                  <Image
                    src={getImageType(isMobileDevice, data)}
                    alt="call"
                    width={0}
                    height={0}
                    className={styles.bannerImg}
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  />
                  <div className={styles.overlay}></div>
                  <div className={styles.play}>
                    <Image
                      src={playIcon || play}
                      onClick={handlePlayVideo}
                      alt="playvideo"
                      height={32}
                      width={32}
                      className={styles.play_btn_cursor}
                      sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                    />
                  </div>
                </>
              ) : (
                <>
                  <VideoPlay
                    height="600px"
                    autoPlay
                    onEnded={handleVideoEnded}
                    onPause={handlePause}
                    onPlay={handlePlay}
                    playing={isPlaying}
                    onSeek={handleSeek}
                    src={data?.hyperlink}
                  />
                  <div className={styles.close}>
                    <Image
                      src={close}
                      onClick={handleCloseVideo}
                      alt="close video"
                      height={32}
                      width={32}
                      className={styles.close_btn_cursor}
                      sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BannerVideo;
